import { render, staticRenderFns } from "./DocumentSidebar.vue?vue&type=template&id=4a5e3ea2"
import script from "./DocumentSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocumentSidebar.vue?vue&type=style&index=0&id=4a5e3ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports